// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__bUb1U","header":"accordion_header__bUb1U","body":"accordion_body__bUb1U","active":"accordion_active__bUb1U","inactive":"accordion_inactive__bUb1U"};